import { definePolicies } from '@libs/shared/frontend/helpers/define-policies.helper';
import { allPass as rAllPass, prop as rProp, piped as rPiped, constant as rConstant } from 'remeda';

import {
  CampaignRequestEditStatusEnum,
  CampaignRequestStatusEnum,
  OrganizationAccessControlModuleEnum,
  CustomerPermissionActionEnum,
  CustomerPermissionSubjectEnum,
  type components,
} from '@/libs/openapi/schema';
import { hasPermissions, hasModule } from '@/utils/permissions.util';

interface PolicyContext {
  user: components['schemas']['MeResponseDto'];
  organization: components['schemas']['OrganizationResponseDto'] | undefined;
}

interface CreatePolicyContext {
  campaignRequest: components['schemas']['CampaignRequestResponseDto'];
  editRequests: components['schemas']['CampaignRequestEditResponseDto'][];
}

export const campaignEditRequestPolicies = definePolicies((globalCtx: PolicyContext) => ({
  view: rConstant(hasModule(globalCtx.organization, OrganizationAccessControlModuleEnum.CAMPAIGN_REQUEST)),
  create: (ctx: CreatePolicyContext) => rAllPass(globalCtx, [
    rPiped(rProp('organization'), hasModule(OrganizationAccessControlModuleEnum.CAMPAIGN_REQUEST)),
    rPiped(rProp('user'), hasPermissions(CustomerPermissionSubjectEnum.CAMPAIGN_REQUEST_EDIT, [
      CustomerPermissionActionEnum.CREATE,
      CustomerPermissionActionEnum.MANAGE,
    ])),
    rConstant(
      ctx.campaignRequest.status === CampaignRequestStatusEnum.ACTIVE ||
      ctx.campaignRequest.status === CampaignRequestStatusEnum.COMPLETED,
    ),
    rConstant(
      !ctx.editRequests.some(({ status }) => status === CampaignRequestEditStatusEnum.IN_REVIEW),
    ),
  ]),
  update: (ctx: components['schemas']['CampaignRequestEditResponseDto']) => rAllPass(globalCtx, [
    rPiped(rProp('organization'), hasModule(OrganizationAccessControlModuleEnum.CAMPAIGN_REQUEST)),
    rPiped(rProp('user'), hasPermissions(CustomerPermissionSubjectEnum.CAMPAIGN_REQUEST_EDIT, [
      CustomerPermissionActionEnum.UPDATE,
      CustomerPermissionActionEnum.MANAGE,
    ])),
    rConstant(ctx.status === CampaignRequestEditStatusEnum.IN_REVIEW),
  ]),
  delete: rConstant(rAllPass(globalCtx, [
    rPiped(rProp('organization'), hasModule(OrganizationAccessControlModuleEnum.CAMPAIGN_REQUEST)),
    rPiped(rProp('user'), hasPermissions(CustomerPermissionSubjectEnum.CAMPAIGN_REQUEST_EDIT, [
      CustomerPermissionActionEnum.DELETE,
      CustomerPermissionActionEnum.MANAGE,
    ])),
  ])),
}));
